import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '../Global/Buttons/Button';
import Icon from '../Global/Icons/Icon';
import OwnerText from '../Global/Conversions/OwnerText';
import VerticalTextLockup from '../Global/Typography/VerticalTextLockup';

const FolderArrowIcon = ({ expanded }) => {
  // toggle folder arrow direction between expanded and collapsed
  if (expanded) {
    return <Icon name="arrow-down" size="m" />;
  }
  return <Icon name="arrow-right" size="m"  />;
};

FolderArrowIcon.propTypes = {
  expanded: PropTypes.bool,
};

const ExpandFolderButton = ({ folder, folderClick, arrowClick, active, expanded, disabled }) => {
  const listClass = classNames(
    `d-flex`,
    { 'bg-green--light': folder.new },
  );

  const folderButtonClass = classNames(`folder-icon-btn`, {
    'folder-icon-btn--disabled': disabled,
  });

  const checkboxClass = classNames(
    `checkbox-input`, {
      'checkbox-input--checked': active,
      'checkbox-input--disabled': disabled,
    },
  );

  return (
    <li className={listClass} style={{ marginLeft: `${10 * folder.level}px` }}>
      <Button onClick={() => arrowClick(folder.id)} faux classes="folder-arrow-btn">
        <FolderArrowIcon expanded={expanded} />
      </Button>

      <Button onClick={() => folderClick(folder.id)} faux classes={folderButtonClass} disabled={disabled}>
        <Icon name="folder" fill="blue" size="m" />

        <VerticalTextLockup
          title={<h3 className="like-p">{folder.title}</h3>}
          subtitle={<div className="like-small"><OwnerText owner={folder.owned_by_me} /></div>}
        />

        <span className={checkboxClass} />
        <span className="faux-label" />
      </Button>
    </li>
  );
};

ExpandFolderButton.propTypes = {
  folder: PropTypes.object.isRequired,
  folderClick: PropTypes.func.isRequired,
  arrowClick: PropTypes.func.isRequired,
  active: PropTypes.bool,
  expanded: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default ExpandFolderButton;



// WEBPACK FOOTER //
// ./library/app/components/Folders/ExpandFolderButton.js